import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const guestAccessEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-products-jsw-guest-access" */ './src/index.tsx'),
	),
	getPreloadProps: () => ({}),
});
